import { ReactElement } from 'react';
import { TextInput } from '@mantine/core';
import { Button } from '../shared/button/Button';
import { useMenuWithCart } from '../../contexts/MenuWithCart';
import { SignupStep } from '../../constants/signup';
import styles from './CreateAccount.module.scss';

export function DisabledEmailSignup(): ReactElement {
  const {
    setCurrentSignupStep,
  } = useMenuWithCart();
  const emailCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('account_creation_email='))
    ?.split('=')[1];

  const email = emailCookie ? decodeURIComponent(emailCookie) : '';
  return (
    <>
      <div className={styles.input_field}>
        <TextInput
          disabled
          label="Email*"
          placeholder={email}
        />
      </div>
      <div className={styles.input_field}>
        <TextInput
          disabled
          label="Password*"
          placeholder="**********"
        />
      </div>
      <Button
        className={styles.full_width}
        data-heap-id="submit_email_signup"
        text="Sign Up with Email"
        onClick={() => setCurrentSignupStep(SignupStep.SHIPPING_ADDRESS)}
        isEnabled
      />
    </>
  );
}
